<div class="container-fluid">
  <div class="row">
    <div style="padding: 0" class="col-md-3">
      <app-auth-side></app-auth-side>
    </div>
    <div class="col-md-9">
      <div class="login d-flex align-items-center py-5">
        <div class="container">
          <div class="row">
            <div class="col-xl-4 mx-auto" [ngSwitch]="selectedPage">
              <p>
                <ngb-progressbar *ngIf="selectedPage <= 4" height="8px" type="info"
                                 [value]="progress"></ngb-progressbar>
              </p>

              <app-verify-store-form [data]="store" (handelAction)="handelAction($event)"
                                     *ngSwitchCase="1"></app-verify-store-form>
              <app-store-description-form [data]="store" (handelAction)="handelAction($event)"
                                          *ngSwitchCase="2"></app-store-description-form>
              <app-store-details-form [data]="store" (handelAction)="handelAction($event)"
                                      *ngSwitchCase="3"></app-store-details-form>
              <app-store-location-form [data]="store" (handelAction)="handelAction($event)"
                                       *ngSwitchCase="4"></app-store-location-form>

              <app-store-created [token]="token" *ngIf="selectedPage === 5"></app-store-created>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ngx-spinner color="rgba(30, 205, 100, 1)" type="ball-scale-multiple"></ngx-spinner>

